export const templates = [
  {
    id: 'restaurante',
    nome: '🍴 Restaurante',
    descricao: 'Delivery e reservas',
    // Declarados aqui, os valores ficam por canal: a MESMA árvore serve
    // várias unidades em vez de virar N cópias do fluxo.
    variaveis: [
      { chave: 'nome_loja', label: 'Nome do restaurante', obrigatoria: true },
      { chave: 'endereco', label: 'Endereço completo', obrigatoria: true },
      { chave: 'link_cardapio', label: 'Link do cardápio', tipo: 'url', obrigatoria: true },
      { chave: 'tempo_entrega', label: 'Tempo de entrega', padrao: '45 minutos' },
      { chave: 'frete_gratis', label: 'Frete grátis acima de', padrao: 'R$ 50' },
    ],
    etapas: [
      { 
        id: 'r1', 
        nome: 'Boas-vindas', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '🍴 *{{nome_loja}}*\n\nOlá *{{nome}}*! 👋\n\nSeja bem-vindo ao nosso atendimento automático.\n\n_Como podemos ajudar você hoje?_ 😊', 
        proxima_etapa_id: 'r2',
        aguardar_resposta: false
      },
      { 
        id: 'r2', 
        nome: 'Menu Principal', 
        tipo_etapa: 'menu', 
        mensagem_automatica: '📋 *MENU PRINCIPAL*\n\nEscolha uma opção:\n\n*1* - 🛵 Fazer pedido delivery\n*2* - 📅 Reservar mesa\n*3* - 📖 Ver cardápio completo\n*4* - ⏰ Horário de funcionamento\n*5* - 📍 Localização\n*0* - 👨‍💼 Falar com atendente', 
        opcoes_menu: [
          {opcao:'1',texto:'Pedido',proxima_etapa_id:'r3'},
          {opcao:'2',texto:'Reserva',proxima_etapa_id:'r4'},
          {opcao:'3',texto:'Cardápio',proxima_etapa_id:'r5'},
          {opcao:'4',texto:'Horário',proxima_etapa_id:'r6'},
          {opcao:'5',texto:'Localização',proxima_etapa_id:'r7'},
          {opcao:'0',texto:'Atendente',proxima_etapa_id:'r8'}
        ]
      },
      { 
        id: 'r3', 
        nome: 'Pedido Delivery', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '🛵 *DELIVERY*\n\nÓtimo *{{nome}}*! Vamos fazer seu pedido.\n\n📱 Acesse nosso cardápio digital:\n{{link_cardapio}}\n\n✅ Entrega em até *{{tempo_entrega}}*\n💳 Aceitamos PIX, cartão e dinheiro\n🆓 *Frete GRÁTIS* acima de {{frete_gratis}}\n\nVocê será transferido para um atendente que vai finalizar seu pedido! 👨‍🍳', 
        proxima_etapa_id: 'r8',
        aguardar_resposta: false
      },
      { 
        id: 'r4', 
        nome: 'Reserva Mesa', 
        tipo_etapa: 'aguardar', 
        mensagem_automatica: '📅 *RESERVA DE MESA*\n\nPerfeito! Vamos reservar sua mesa.\n\nPor favor, informe:\n• Data e horário desejado\n• Número de pessoas\n• Alguma preferência especial?\n\n_Aguardando sua resposta..._', 
        proxima_etapa_id: 'r9',
        timeout: 300,
        fallback_etapa_id: 'r10'
      },
      { 
        id: 'r5', 
        nome: 'Cardápio', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '📖 *CARDÁPIO COMPLETO*\n\n🍽️ *PRATOS PRINCIPAIS*\nFilé ao molho madeira - R$ 85,00\nSalmão grelhado - R$ 78,00\nRisoto de camarão - R$ 72,00\nPicanha na chapa - R$ 95,00\n\n🍰 *SOBREMESAS*\nPetit Gâteau - R$ 28,00\nTiramisù - R$ 25,00\nCheesecake - R$ 22,00\n\n🍷 *BEBIDAS*\nVinhos - R$ 45 a R$ 180\nCervejas artesanais - R$ 18\nSucos naturais - R$ 12\n\n_Todos os pratos servem 1 pessoa_', 
        proxima_etapa_id: 'r2',
        aguardar_resposta: false
      },
      { 
        id: 'r6', 
        nome: 'Horário', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '⏰ *HORÁRIO DE FUNCIONAMENTO*\n\n🗓️ Segunda a Quinta\n11h às 23h\n\n🎉 Sexta e Sábado\n11h à 00h (meia-noite)\n\n☀️ Domingo\n11h às 22h\n\n_Cozinha fecha 30min antes do encerramento_', 
        proxima_etapa_id: 'r2',
        aguardar_resposta: false
      },
      { 
        id: 'r7', 
        nome: 'Localização', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '📍 *NOSSA LOCALIZAÇÃO*\n\n{{endereco}}\n\n🚗 Estacionamento gratuito\n♿ Acessível para cadeirantes\n\n_Nos vemos em breve!_ 😊', 
        proxima_etapa_id: 'r2',
        aguardar_resposta: false
      },
      { 
        id: 'r8', 
        nome: 'Transferir Atendente', 
        tipo_etapa: 'aguardar', 
        mensagem_automatica: '👨‍💼 *TRANSFERINDO...*\n\nAguarde um momento, *{{nome}}*.\n\nVocê será atendido por um de nossos colaboradores em instantes! ⏱️', 
        proxima_etapa_id: 'r11'
      },
      { 
        id: 'r9', 
        nome: 'Confirmar Reserva', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '✅ *RESERVA RECEBIDA*\n\nObrigado pelas informações!\n\nUm atendente vai confirmar sua reserva em breve e enviar todos os detalhes.\n\n_Aguarde o contato!_ 📱', 
        proxima_etapa_id: 'r11',
        aguardar_resposta: false
      },
      { 
        id: 'r10', 
        nome: 'Timeout Reserva', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '⏰ *TEMPO ESGOTADO*\n\nNão recebemos sua resposta.\n\nSe ainda deseja fazer uma reserva, digite *2* para voltar ao menu ou fale com um atendente digitando *0*.', 
        proxima_etapa_id: 'r2',
        aguardar_resposta: true,
        timeout: 180
      },
      { 
        id: 'r11', 
        nome: 'Finalizar', 
        tipo_etapa: 'finalizar', 
        mensagem_automatica: '🍴 *{{nome_loja}}*\n\nObrigado pelo contato! 😊\n\nAté breve! 👋'
      }
    ]
  },
  {
    id: 'ecommerce',
    nome: '🛍️ E-commerce',
    descricao: 'Loja online',
    etapas: [
      { 
        id: 'e1', 
        nome: 'Boas-vindas', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '🛍️ *TechStore Brasil*\n\nOlá *{{nome}}*! 💻\n\nBem-vindo à maior loja de tecnologia do Brasil!\n\n_Estamos aqui para ajudar você!_ 🚀', 
        proxima_etapa_id: 'e2',
        aguardar_resposta: false
      },
      { 
        id: 'e2', 
        nome: 'Menu Principal', 
        tipo_etapa: 'menu', 
        mensagem_automatica: '📱 *O QUE VOCÊ PROCURA?*\n\n*1* - 🛒 Ver produtos em destaque\n*2* - 📦 Rastrear meu pedido\n*3* - 🔄 Trocas e devoluções\n*4* - 💳 Formas de pagamento\n*5* - 🎁 Cupons de desconto\n*0* - 👨‍💻 Suporte técnico', 
        opcoes_menu: [
          {opcao:'1',texto:'Produtos',proxima_etapa_id:'e3'},
          {opcao:'2',texto:'Rastrear',proxima_etapa_id:'e4'},
          {opcao:'3',texto:'Trocas',proxima_etapa_id:'e5'},
          {opcao:'4',texto:'Pagamento',proxima_etapa_id:'e6'},
          {opcao:'5',texto:'Cupons',proxima_etapa_id:'e7'},
          {opcao:'0',texto:'Suporte',proxima_etapa_id:'e8'}
        ]
      },
      { 
        id: 'e3', 
        nome: 'Produtos', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '🔥 *OFERTAS IMPERDÍVEIS*\n\n💻 Notebook Gamer - ~R$ 4.999~ *R$ 3.999*\n📱 Smartphone 5G - ~R$ 2.499~ *R$ 1.899*\n🎧 Fone Bluetooth - ~R$ 399~ *R$ 299*\n⌚ Smartwatch - ~R$ 899~ *R$ 699*\n\n🌐 Acesse nosso site:\nwww.techstore.com.br\n\n✅ *Frete GRÁTIS* acima de R$ 299\n💳 Até *12x sem juros*\n📦 Entrega em todo Brasil', 
        proxima_etapa_id: 'e2',
        aguardar_resposta: false
      },
      { 
        id: 'e4', 
        nome: 'Rastreio', 
        tipo_etapa: 'aguardar', 
        mensagem_automatica: '📦 *RASTREAMENTO DE PEDIDO*\n\nPor favor, informe o *número do seu pedido*.\n\nVocê pode encontrar no e-mail de confirmação ou na sua conta.\n\n_Formato: TS123456_\n\nAguardando...', 
        proxima_etapa_id: 'e9',
        timeout: 180,
        fallback_etapa_id: 'e10'
      },
      { 
        id: 'e5', 
        nome: 'Trocas', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '🔄 *TROCAS E DEVOLUÇÕES*\n\n✅ Até *30 dias* para trocar\n📦 Produto na embalagem original\n🆓 Primeira troca *GRÁTIS*\n\n*COMO SOLICITAR:*\n1. Acesse: devolucoes.techstore.com.br\n2. Informe número do pedido\n3. Escolha o motivo\n4. Imprima a etiqueta\n\n📧 Dúvidas: suporte@techstore.com.br\n📞 SAC: 0800-123-4567', 
        proxima_etapa_id: 'e2',
        aguardar_resposta: false
      },
      { 
        id: 'e6', 
        nome: 'Pagamento', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '💳 *FORMAS DE PAGAMENTO*\n\n✅ *Cartão de Crédito*\nVisa, Master, Elo, Amex\nAté 12x sem juros\n\n✅ *PIX*\nDesconto de 5%\nAprovação instantânea\n\n✅ *Boleto Bancário*\nVencimento em 3 dias\n\n✅ *Carteira Digital*\nPicPay, Mercado Pago\n\n_Ambiente 100% seguro_ 🔒', 
        proxima_etapa_id: 'e2',
        aguardar_resposta: false
      },
      { 
        id: 'e7', 
        nome: 'Cupons', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '🎁 *CUPONS DE DESCONTO*\n\n*PRIMEIRA COMPRA*\nCupom: ~BEMVINDO10~\nDesconto: 10% OFF\n\n*FRETE GRÁTIS*\nCupom: ~FRETEGRATIS~\nPara compras acima de R$ 199\n\n*BLACK FRIDAY*\nCupom: ~BLACK50~\nDesconto: 50% OFF\n_Válido até 30/11_\n\n💡 *Dica:* Insira o cupom no carrinho antes de finalizar!', 
        proxima_etapa_id: 'e2',
        aguardar_resposta: false
      },
      { 
        id: 'e8', 
        nome: 'Suporte', 
        tipo_etapa: 'aguardar', 
        mensagem_automatica: '👨‍💻 *SUPORTE TÉCNICO*\n\nOlá *{{nome}}*!\n\nDescreva seu problema ou dúvida que um especialista vai te ajudar.\n\n_Nossa equipe está pronta para atender você!_ ⚡', 
        proxima_etapa_id: 'e11'
      },
      { 
        id: 'e9', 
        nome: 'Processar Rastreio', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '✅ *PEDIDO LOCALIZADO*\n\nUm atendente vai verificar o status do seu pedido e te enviar todas as informações de rastreamento.\n\n_Aguarde um momento!_ 📱', 
        proxima_etapa_id: 'e11',
        aguardar_resposta: false
      },
      { 
        id: 'e10', 
        nome: 'Timeout Rastreio', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '⏰ Não recebemos o número do pedido.\n\nSe precisar de ajuda, fale com nosso suporte digitando *0* ou volte ao menu digitando *#*.', 
        proxima_etapa_id: 'e2',
        aguardar_resposta: true,
        timeout: 120
      },
      { 
        id: 'e11', 
        nome: 'Finalizar', 
        tipo_etapa: 'finalizar', 
        mensagem_automatica: '🛍️ *TechStore Brasil*\n\nObrigado pelo contato, *{{nome}}*! 🚀\n\nEstamos sempre à disposição!\n\n_Até a próxima!_ 😊'
      }
    ]
  },
  {
    id: 'clinica',
    nome: '🏥 Clínica',
    descricao: 'Agendamento médico',
    etapas: [
      { 
        id: 'c1', 
        nome: 'Recepção', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '🏥 *Clínica Saúde & Vida*\n\nOlá *{{nome}}*! ❤️\n\nSeja bem-vindo(a) ao nosso atendimento.\n\n_Estamos aqui para cuidar de você!_ 🩺', 
        proxima_etapa_id: 'c2',
        aguardar_resposta: false
      },
      { 
        id: 'c2', 
        nome: 'Menu Principal', 
        tipo_etapa: 'menu', 
        mensagem_automatica: '📋 *COMO PODEMOS AJUDAR?*\n\n*1* - 📅 Agendar consulta\n*2* - 🔬 Resultados de exames\n*3* - 👨‍⚕️ Especialidades médicas\n*4* - 💊 Convênios aceitos\n*5* - 📍 Localização e horários\n*0* - 🚨 Emergência', 
        opcoes_menu: [
          {opcao:'1',texto:'Agendar',proxima_etapa_id:'c3'},
          {opcao:'2',texto:'Exames',proxima_etapa_id:'c4'},
          {opcao:'3',texto:'Especialidades',proxima_etapa_id:'c5'},
          {opcao:'4',texto:'Convênios',proxima_etapa_id:'c6'},
          {opcao:'5',texto:'Localização',proxima_etapa_id:'c7'},
          {opcao:'0',texto:'Emergência',proxima_etapa_id:'c8'}
        ]
      },
      { 
        id: 'c3', 
        nome: 'Agendamento', 
        tipo_etapa: 'aguardar', 
        mensagem_automatica: '📅 *AGENDAMENTO DE CONSULTA*\n\nPor favor, informe:\n\n• Especialidade desejada\n• Data preferencial\n• Período (manhã/tarde)\n• Convênio ou particular\n\n_Aguardando suas informações..._', 
        proxima_etapa_id: 'c9',
        timeout: 300,
        fallback_etapa_id: 'c10'
      },
      { 
        id: 'c4', 
        nome: 'Exames', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '🔬 *RESULTADOS DE EXAMES*\n\n*ACESSO ONLINE:*\n🌐 resultados.saudevida.com.br\n\n*INFORMAÇÕES NECESSÁRIAS:*\n• CPF do paciente\n• Data de nascimento\n• Código do exame\n\n📱 Resultados disponíveis em até 48h\n🔒 Acesso seguro e criptografado\n\n_Dúvidas? Fale com nossa equipe!_ 💚', 
        proxima_etapa_id: 'c2',
        aguardar_resposta: false
      },
      { 
        id: 'c5', 
        nome: 'Especialidades', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '👨‍⚕️ *ESPECIALIDADES MÉDICAS*\n\n🩺 *Clínica Geral*\n❤️ *Cardiologia*\n🦴 *Ortopedia*\n👶 *Pediatria*\n👵 *Geriatria*\n🧠 *Neurologia*\n👁️ *Oftalmologia*\n🦷 *Odontologia*\n🤰 *Ginecologia*\n🫁 *Pneumologia*\n\n_E muito mais!_\n\nTodos os médicos são especialistas certificados pelo CRM. ✅', 
        proxima_etapa_id: 'c2',
        aguardar_resposta: false
      },
      { 
        id: 'c6', 
        nome: 'Convênios', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '💊 *CONVÊNIOS ACEITOS*\n\n✅ Unimed\n✅ Bradesco Saúde\n✅ SulAmérica\n✅ Amil\n✅ NotreDame Intermédica\n✅ Porto Seguro\n✅ Golden Cross\n✅ Particular\n\n💰 *VALORES PARTICULARES:*\nConsulta: R$ 200 a R$ 350\nExames: Sob consulta\n\n_Parcelamos em até 3x sem juros_ 💳', 
        proxima_etapa_id: 'c2',
        aguardar_resposta: false
      },
      { 
        id: 'c7', 
        nome: 'Localização', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '📍 *LOCALIZAÇÃO*\n\nAv. Saúde, 456\nCentro Médico - 3º andar\nSão Paulo - SP\nCEP: 04567-890\n\n⏰ *HORÁRIOS:*\nSeg a Sex: 7h às 19h\nSábado: 8h às 13h\n\n🚗 Estacionamento conveniado\n🚇 Metrô: Estação Saúde (200m)\n♿ Totalmente acessível\n\n_Esperamos por você!_ 💚', 
        proxima_etapa_id: 'c2',
        aguardar_resposta: false
      },
      { 
        id: 'c8', 
        nome: 'Emergência', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '🚨 *EMERGÊNCIA*\n\n*EM CASO DE URGÊNCIA:*\n\n📞 *LIGUE IMEDIATAMENTE:*\n(11) 3456-7890\n\n🚑 *SAMU: 192*\n🚒 *BOMBEIROS: 193*\n\n⚠️ Nossa clínica não possui pronto-socorro 24h.\n\nPara emergências, procure o hospital mais próximo!\n\n_Cuide-se!_ ❤️', 
        proxima_etapa_id: 'c11',
        aguardar_resposta: false
      },
      { 
        id: 'c9', 
        nome: 'Confirmar Agendamento', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '✅ *SOLICITAÇÃO RECEBIDA*\n\nObrigado pelas informações, *{{nome}}*!\n\nNossa equipe vai verificar a disponibilidade e confirmar seu agendamento em breve.\n\n📱 Você receberá uma mensagem com:\n• Data e horário confirmados\n• Nome do médico\n• Instruções para a consulta\n\n_Aguarde nosso contato!_ 💚', 
        proxima_etapa_id: 'c11',
        aguardar_resposta: false
      },
      { 
        id: 'c10', 
        nome: 'Timeout Agendamento', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '⏰ Não recebemos suas informações.\n\nSe ainda deseja agendar, digite *1* ou fale com nossa recepção digitando *#* para voltar ao menu.', 
        proxima_etapa_id: 'c2',
        aguardar_resposta: true,
        timeout: 180
      },
      { 
        id: 'c11', 
        nome: 'Finalizar', 
        tipo_etapa: 'finalizar', 
        mensagem_automatica: '🏥 *Clínica Saúde & Vida*\n\nObrigado pelo contato! ❤️\n\n_Cuide-se e até breve!_ 💚'
      }
    ]
  },
  {
    id: 'simples',
    nome: '⚡ Básico',
    descricao: 'Template simples',
    etapas: [
      { 
        id: 's1', 
        nome: 'Saudação', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: '*Olá {{nome}}!* 👋\n\nBem-vindo ao nosso atendimento automático.\n\n_Estamos aqui para ajudar!_ 😊', 
        proxima_etapa_id: 's2',
        aguardar_resposta: false
      },
      { 
        id: 's2', 
        nome: 'Menu', 
        tipo_etapa: 'menu', 
        mensagem_automatica: '📋 *MENU*\n\nEscolha uma opção:\n\n*1* - ℹ️ Informações\n*2* - 👨‍💼 Falar com atendente\n*3* - ❌ Sair', 
        opcoes_menu: [
          {opcao:'1',texto:'Info',proxima_etapa_id:'s3'},
          {opcao:'2',texto:'Atendente',proxima_etapa_id:'s4'},
          {opcao:'3',texto:'Sair',proxima_etapa_id:'s5'}
        ]
      },
      { 
        id: 's3', 
        nome: 'Informações', 
        tipo_etapa: 'mensagem', 
        mensagem_automatica: 'ℹ️ *INFORMAÇÕES*\n\n📞 Telefone: (11) 1234-5678\n📧 E-mail: contato@empresa.com.br\n🌐 Site: www.empresa.com.br\n\n⏰ *Horário de atendimento:*\nSeg a Sex: 9h às 18h\n\n_Estamos à disposição!_ 💼', 
        proxima_etapa_id: 's2',
        aguardar_resposta: false
      },
      { 
        id: 's4', 
        nome: 'Transferir', 
        tipo_etapa: 'aguardar', 
        mensagem_automatica: '👨‍💼 *TRANSFERINDO...*\n\nAguarde um momento, *{{nome}}*.\n\nVocê será atendido em breve! ⏱️', 
        proxima_etapa_id: 's5',
        timeout: 300
      },
      { 
        id: 's5', 
        nome: 'Finalizar', 
        tipo_etapa: 'finalizar', 
        mensagem_automatica: 'Obrigado pelo contato! 😊\n\n_Até breve!_ 👋'
      }
    ]
  }
];
